import { EventTypes } from '../types';
import { buildMixpanelEvent } from './builders';

const { encourageSellerReply } = EventTypes;

export const MixpanelEvents = {
    [encourageSellerReply.shown]: buildMixpanelEvent('Communication - Encourage Seller Reply - Shown'),
    [encourageSellerReply.hovered]: buildMixpanelEvent('Communication - Encourage Seller Reply - Hovered'),
    [encourageSellerReply.closed]: buildMixpanelEvent('Communication - Encourage Seller Reply - Closed'),
    [encourageSellerReply.minimized]: buildMixpanelEvent('Communication - Encourage Seller Reply - Minimized'),
    [encourageSellerReply.clickedOnBuyerName]: buildMixpanelEvent(
        'Communication - Encourage Seller Reply - Clicked on buyer name'
    ),
    [encourageSellerReply.clickedOnBubble]: buildMixpanelEvent(
        'Communication - Encourage Seller Reply - Clicked on bubble'
    ),
};
